import React from 'react';
import { InformationPanel } from '@gerdau/hefesto-mais-web';
import {
  TableHeaderColumnContainer,
  TableHeaderColumnItems,
  TableHeaderInput
} from './styles';
import { HeaderColumnProps } from './types';
import { Button, Icon, TextField } from '@gerdau/hefesto';

export const HeaderColumnTable = ({
  title,
  column,
  options,
  debounce,
  width,
  lastColumns,
  value,
  showFilter
}: HeaderColumnProps) => {
  const [inputValue, setInputValue] = React.useState(value);

  React.useEffect(() => {
    if (value === '') {
      setInputValue(value);
    }
  }, [value]);

  return (
    <TableHeaderColumnContainer width={width}>
      <TableHeaderColumnItems>
        <span>{title}</span>
        {options && options.length > 0 && (
          <InformationPanel
            trigger={
              <div>
                <Button
                  name="columnActions"
                  variant="neutral"
                  icon={<Icon option="MoreVertical"></Icon>}
                />
              </div>
            }
            position={lastColumns ? 'bottom right' : 'bottom left'}
            title="Ações"
            panelOptions={options}
          />
        )}
      </TableHeaderColumnItems>

      {showFilter !== false && (
        <TableHeaderInput>
          <TextField
            label={''}
            name={column}
            type={'text'}
            value={inputValue}
            icon={<Icon option="Filter" />}
            iconPosition={'left'}
            onChange={(e) => {
              setInputValue(e.target.value);
              debounce({ column, value: e.target.value });
            }}
          />
        </TableHeaderInput>
      )}
    </TableHeaderColumnContainer>
  );
};
